import { render } from "./LineChartL.vue?vue&type=template&id=d178667a&scoped=true"
import script from "./LineChartL.vue?vue&type=script&lang=ts"
export * from "./LineChartL.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d178667a"

export default script